// React-Screen CPrepaidCardPayment ("Wertkarten-Zahlung") - Strangler Phase 5.
// Ersetzt die ESM-Huelle screens/prepaidcardpayment.js.
// Fixture: tests/react-fixtures/CPrepaidCardPayment.html, Baseline:
// Galerie-Eintrag 36-wertkarten-zahlung.
//
// DIESER SCREEN FASST GELD AN (Wertkarten aufladen und damit bezahlen). Alle
// 33 Legacy-Methoden sind WOERTLICH uebernommen - maschinell extrahiert, mit
// Klammerzaehlung statt der frueher benutzten "erste Zeile mit }"-Heuristik:
// die haette hier updateDisplay() verschluckt, und die Syntaxpruefung waere
// trotzdem gruen gewesen (compiliert heisst nicht vollstaendig).
//
// AUFBAU: prepare() baute die Kinder aus ZWEI Layout-XMLs -
//   LYT_bonOverlay.xml        -> 0..8  (dieselben neun wie CTransactionShowMode)
//   LYT_prepaidCardsOverlay.xml -> 9..14 (ppOverlay, closeButton, fillFrame,
//                                         chargeButton, payButton, creditLabel)
// Das uebernimmt die JSX. Die acht SCHEINTASTEN bleiben ECHTE Legacy-Kinder
// aus makeNoteButtons() - bewusst nicht in JSX, denn welche davon ueberhaupt
// im DOM landen, haengt vom Zustand ab: die "0"-Taste bricht mit continue ab
// (nie gezeichnet), und das "X" nur, wenn getAmounts() etwas liefert. Deshalb
// fehlen in der Fixture die Indizes 15 und 19.
//
// CLASS-AUS-WERT: prepare() setzt titleText.properties.value VOR dem Bauen,
// der Builder schreibt den Wert deshalb mit in die Klasse
// ("CCaption titletext Wertkarte Betragseingabe"). reValue() danach aendert
// nur noch den Text, nie die Klasse - genau wie bei CTransactionShowMode.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';
import { KnopfAusHandle } from '../widgets.jsx';

// classValue = eingefrorener Bauzeit-Wert (Klasse), value = Zustand (Text).
function Caption({ bridge, path, addclass, classValue, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' +
    (classValue === undefined ? value : classValue);
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

const XML_EMPTY = ' ';
// Vorgabewert aus LYT_prepaidCardsOverlay.xml (creditLabel) - zugleich der
// eingefrorene Klassen-Schwanz, den updateDisplay() spaeter NICHT mehr aendert.
const XML_CREDIT = 'Guthaben aktuell';

// Stile aus der FIXTURE, nicht aus der XML - Laufzeit-Zuweisungen und
// Schluessel-Reihenfolge sind aus der XML nicht ableitbar (Lektion CMainPOS).
const S = {
  rahmen: { position: 'absolute' },
  inhalt: { fontSize: '3.0vh' },
  preis: { fontSize: '3.0vh', textAlign: 'right', top: '13%' },
  ppOverlay: { position: 'absolute', overflow: 'hidden', borderStyle: 'solid',
               borderWidth: '2px', height: '10%', width: '117%', top: '0px', left: '102%' },
  schliessen: { position: 'absolute', left: '208%', top: '0.5%', width: '8%', height: '8%',
                backgroundImage: 'url(lib/img/08_X.png)', backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center' },
  fuellRahmen: { position: 'absolute', width: '45vw', height: '30vh', left: '102%',
                 top: '72vh', border: '0px solid #FF0000' },
  aufladen: { position: 'absolute', left: '25%', top: '78%', width: '20%', height: '10%' },
  bezahlen: { position: 'absolute', left: '50%', top: '78%', width: '20%', height: '10%' },
  guthaben: { position: 'absolute', left: '25%', top: '60%', fontSize: '2.4vh',
              fontWeight: 'bold', width: '45vw' },
};

function PrepaidCardPaymentScreen({ bridge }) {
  const knopf = (pfad, fn, extra = {}) => bridge.widget(pfad, 'CPushButton', {
    events: { onMousedown: fn, onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id, ...extra },
    proto: CPushButton.prototype,
  });


  // NAMENSREGISTER bei JEDEM Rendern (siehe bridge.nameComponent): fremder
  // Legacy-Code UND die 33 uebernommenen Methoden adressieren ueber
  // this.components.<name> - ohne das stirbt z.B. updateDisplay().
  [[0,'wholeOverlay'],[1,'overlay'],[2,'titleBack'],[3,'titleText'],
   [4,'contentText'],[5,'priceText'],[6,'unitsText'],[7,'okButton'],
   [8,'backButton'],[9,'ppOverlay'],[10,'closeButton'],[11,'fillFrame'],
   [12,'chargeButton'],[13,'payButton'],[14,'creditLabel']]
    .forEach(([i, n]) => bridge.nameComponent(String(i), n));

  return (
    <>
      {/* --- LYT_bonOverlay.xml: 0..8 --- */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={S.rahmen}></div>
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={S.rahmen}></div>
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={S.rahmen}></div>
      <Caption bridge={bridge} path="3" addclass="titletext"
               classValue={bridge.state.titelKlasse} value={bridge.state.titel} />
      <Caption bridge={bridge} path="4" addclass="contenttext" classValue={XML_EMPTY}
               value={bridge.state.inhalt} style={S.inhalt} />
      <Caption bridge={bridge} path="5" addclass="pricetext" classValue={XML_EMPTY}
               value={bridge.state.preis} style={S.preis} />
      <Caption bridge={bridge} path="6" addclass="unitstext" value={XML_EMPTY} />
      {/* okButton - prepare() stellt ihn dauerhaft auf hidden */}
      <div {...bridge.el('7', 'CPushButton', { proto: CPushButton.prototype })}
           className="CPushButton okbutton" style={{ visibility: 'hidden' }}>
        <Caption bridge={bridge} path="7:0" addclass="" value={XML_EMPTY} />
      </div>
      {/* backButton -> close */}
      <div {...knopf('8', bridge.close)} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>

      {/* --- LYT_prepaidCardsOverlay.xml: 9..14 --- */}
      <div {...bridge.el('9', 'CFrame')} className="CFrame" style={S.ppOverlay}></div>
      {/* closeButton: im Legacy ist sein Handler AUSKOMMENTIERT (prepare),
          der Knopf ist also bewusst wirkungslos - hier genauso. */}
      <div {...bridge.el('10', 'CPushButton', { proto: CPushButton.prototype })}
           className="CPushButton" style={S.schliessen}>
        <p {...bridge.el('10:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
      <div {...bridge.el('11', 'CFrame')} className="CFrame" style={S.fuellRahmen}></div>
      <div {...knopf('12', bridge.charge)} className="CPushButton" style={S.aufladen}>
        <Caption bridge={bridge} path="12:0" addclass="" value="Aufladen" />
      </div>
      <div {...knopf('13', bridge.payment)} className="CPushButton" style={S.bezahlen}>
        <Caption bridge={bridge} path="13:0" addclass="" value="Bezahlen" />
      </div>
      <Caption bridge={bridge} path="14" addclass="" classValue={XML_CREDIT}
               value={bridge.state.guthaben}
               style={S.guthaben} />
      {/* SCHEINTASTEN (15..22): das DOM baut React, die WERTE bleiben in den
          Handles, die makeNoteButtons() befuellt - dieselbe Rechnung wie im
          Legacy, Zeile fuer Zeile. Nicht jede Taste wird gezeichnet: Index 0
          bricht mit continue ab, das "X" (Index 4) nur bei getAmounts().
          Genau deshalb steht hier eine Liste aus dem Zustand und keine feste
          Schleife - und deshalb fehlen in der Baseline die Pfade 15 und 19.
          Handles gibt es fuer ALLE acht (makeNoteButtons legt sie an), damit
          noteButtons[0].properties... weiter zieht; nur das Element fehlt. */}
      {(bridge.state.notizKnoepfe || []).map((gezeichnet, i) =>
        gezeichnet ? <KnopfAusHandle key={i} bridge={bridge} pfad={String(15 + i)} /> : null)}
    </>
  );
}

// ===== 33 Legacy-Methoden, WOERTLICH aus prepaidcardpayment.js ============
// (maschinell mit Klammerzaehlung extrahiert; 'this' ist das Handle)
const legacy = {};

legacy.getAmounts = function() {
    this.openSum = this.Main.BonManager.getSumArray()[6];

    if (!this.openSum)
        return ""

    var message = float2StringD2(this.payAmount) + " &euro;<br>" +
        float2StringD2(this.openSum) + " &euro;";

    return message;
}

legacy.makeNoteButtons = function() {
    this.noteButtons = new Array();
    var gezeichnet = [false, false, false, false, false, false, false, false];
    var values = new Array("0", "5", "10", "20", "X", "50", "100", "200");
    var images = Array(
        "",
        "lib/img/currency/EUR/5.png",
        "lib/img/currency/EUR/10.png",
        "lib/img/currency/EUR/20.png",
        "lib/img/currency/EUR/sum.png",
        "lib/img/currency/EUR/50.png",
        "lib/img/currency/EUR/100.png",
        "lib/img/currency/EUR/200.png");

    var left = 20;

    for (var i = 0; i < 8; i++) {
        // Handle an FESTEM Pfad (15+i) statt addChild: der Index muss
        // derselbe bleiben, sonst verschiebt sich die ganze Kindfolge.
        this.noteButtons[i] = this.widgetHandle(String(15 + i));

        if (i == 0) {
            this.noteButtons[i].properties.styles.visibility = "hidden";
            continue;
        }

        this.noteButtons[i].properties.events.onMousedown = this.sumNoteAmount;
        this.noteButtons[i].properties.attributes.onMousedown_parameter_0 = this.id;
        this.noteButtons[i].properties.attributes.onMousedown_parameter_1 = values[i];
        this.noteButtons[i].properties.styles.position = "absolute";
        this.noteButtons[i].properties.styles.zIndex = "0";
        if (i < 4)
            this.noteButtons[i].properties.styles.top = "15%";
        else {
            this.noteButtons[i].properties.styles.top = "35%";
            if (i == 4)
                left = 0;
        }
        this.noteButtons[i].properties.styles.width = "16%";
        this.noteButtons[i].properties.styles.height = "12%";
        this.noteButtons[i].properties.styles.left = left + "%";
        this.noteButtons[i].properties.styles.backgroundColor = "#AAAAFF";
        this.noteButtons[i].properties.styles.borderColor = "#8888FF";
        this.noteButtons[i].properties.styles.backgroundRepeat = "no-repeat";
        this.noteButtons[i].properties.styles.backgroundPosition = "center";
        this.noteButtons[i].properties.styles.backgroundImage = "url(" + images[i] + ")";
        this.noteButtons[i].properties.styles.backgroundSize = "cover";
        //this.noteButtons[i].properties.styles.backgroundSize = "contain";

        left += 20;

        if (!this.getAmounts() && values[i] == "X")
            continue;

        gezeichnet[i] = true;   // statt draw() - React zeichnet
    }

    // Erst jetzt neu rendern: makeNoteButtons wird VON AUSSEN nach draw()
    // gerufen (CMainPOS, sessionhandler), die Tasten erscheinen also in einem
    // zweiten Durchgang - genau wie das Legacy sie nachtraeglich anhaengte.
    this.update({ notizKnoepfe: gezeichnet });
}

legacy.initPayment = function() {

    var sql = "SELECT POS_ID,Name from SHOPS";
    var me = this;

    me.shops = new Object();
    $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
        for (var i = 0; i < rows.length; i++) {
            me.shops[rows[i].POS_ID] = rows[i].Name;

        }

        //$.when(POS.DataExport.createTunnelToMySQL()).then(function () {
        me.sendPPCPing(me);
    }); //});
}

legacy.sendPPCPing = function(me) {
    POS.hourGlass.show(POS.lang.getText("MESSAGES", "PLEASE_WAIT"));
    me.sendQuery("SELECT *,FROM_UNIXTIME(TS,'%Y-%m-%d %H:%i') as Datum FROM logi.PPCARD_TRANSACTIONS where CardNumber='" + me.cardNumber+"' order by TS", me.pingCallback);
}

legacy.testPPCPing = function(me) {
    return me.sendQuery("SELECT 1", me.pingPPCCallback);
}

legacy.sendQuery = function(sql, callback, counter) {
var me = this;
 	$.when(new CRunClient().sendQuery(sql, callback, "logi")).then(function(error) {
		// Main fehlt, wenn die Instanz nie gezeichnet wurde (Storno ruft
		// addCancelledCharge/-Payment auf einem frischen new CPrepaidCardPayment) -
		// doClose wuerde dann an me.Main.components scheitern.
		if (error && me.Main){
			me.doClose(me);
		}
		
	})

return;

}

legacy.pingPPCCallback = function(data) {
    try {
        var me = POS.sessions.getSessionComponent().cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }

    me.pingVTSuccess = true;
}

legacy.testPing = function(me) {
    /*var d = new Date();
    var newTS = (d / 1000).toFixed(0);

    if (newTS - me.pingTS > 15) {
    	POS.hourGlass.hide();
    	if (POS.sessions.getSessionComponent() == me.Main) {
    		var text = POS.lang.getText("MESSAGES", "PING_TOO_LONG");
    		POS.message.show(text, "warning", "OK");
    		if (typeof POS.EnvProperties.PINGVT != "undefined" && POS.EnvProperties.PINGVT == "YES")
    			Trans.registerPingFailure(me.pingVTSuccess);
    	}
    	me.doClose(me);
    	return;
    }
    me.sendPPCPing(me);
    POS.timeout.register("testPPCPaymentPing", me.testPing, me, me.pingFreq, 1);*/
}

legacy.pingCallback = function(data, err) {

    var defret = $.Deferred();

    var currentSession = POS.sessions.getSessionComponent();
    var me = currentSession.cmpPrepaidPayment;

    var credits = 0;
    var debits = 0;
    me.data = data;
    for (var i in data) {
        if (data[i].Type == "IN") {
            credits = credits + Number(data[i].Amount);
        } else if (data[i].Type == "OUT") {
            debits = debits + Number(data[i].Amount);
        }
    }

    me.availableCredit = debits + credits; // credits is negative

    me.updateDisplay();

    // React zeichnet: den Text in den Zustand, NICHT creditLabel.draw() - das
    // ist Legacy-Zeichnen ueber builder.addElement, das ein React-Handle
    // nicht hat. Es warf bei JEDEM Wertkarten-Scan und die Kasse startete
    // neu zur Anmeldung (Testkasse 29./30.9.2026).
    me.update({ guthaben: "Guthaben aktuell:       " + Math.round(me.availableCredit * 100) / 100 + " &euro;" });

    var d = new Date();
    me.pingTS = (d / 1000).toFixed(0);

    /*if (!me.online) {
    	var source = "http://" + me.orderWeb + me.cardNumber;
    	if (me.Main.BonManager.currentBonId)
    		source += ";curr_bon=" + me.Main.BonManager.currentBonId;
    	me.components.orderFrame.properties.attributes.src = source;
    	me.components.orderFrame.reAttribute();
    	me.online = true;
    }*/

 //   var frameid = me.components.orderFrame.id;
 //   var framename = me.components.orderFrame.name + ":" + me.components.orderFrame.id;
    //me.createOrderTable(data);
    //jQuery( "[attribute='value']" )
    if (data) {
	var parentclass = $("#"+me.id.split(":")[0]);
        $("<div id=orderframe>").appendTo(parentclass);
        $("#orderframe").append(me.createOrderTable(data));
    }
    POS.hourGlass.hide();
    defret.resolve(1);
    return defret.promise();
}

legacy.createOrderTable = function(rows) {

    var me = this;
    var header = ["Filiale", "Datum", "Typ", "Rechnnr", "Betrag"];
    var fields = ["POS_ID", "Datum", "Type", "BillNumber", "Amount"];
    var fieldalign = ["left", "center", "center", "center", "right"];
    var table = $('<table>');
    var thead = $('<thead>');

    var tr = $('<tr>');

    var i = 0;

    for (i = 0; i < header.length; i++) {

        var th = $('<th>');

        th.append(header[i]);
        th.css('border-style', "solid");
        th.css('border-width', "2px");
        th.css('padding', "3px");
        tr.append(th);
    }

    thead.append(tr);

    table.append(thead);
    var tbody = $('<tbody>');

    for (i = rows.length - 1; i > -1; i--) {

        var tr = $('<tr>');
        for (var j = 0; j < fields.length; j++) {
            var td = $('<td>');
            var val = rows[i][fields[j]];
            if (j == 2) {
                if (val == "OUT") {
                    val = "Bezahlen";
                } else if (val == "IN") {
                    val = "Aufladen";
                }
            } else if (j == 4) {
                val = val + " &euro;";
            } else if (j == 0) {
                if (me.shops[val]) {
                    val = me.shops[val];
                }
            }
            td.append(val);
            td.css('border-style', "solid");
            td.css('border-width', "1px");
            td.css('padding', "3px");
            td.css('text-align', fieldalign[j]);
            tr.append(td);
        }
        tbody.append(tr);
    }
    table.append(tbody);

    table.css('width', "44vw");
    //table.css('height', "20vh");
    table.css('left', "5%");
    table.css('top', "5%");
    table.css('border-style', "solid");
    table.css('border-width', "2px");
    return table;
}

legacy.sumNoteAmount = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);
    var noteAmount = parameters[1];

    me.Main.BonManager.switchSumInfo(false);

    if (noteAmount == "X")
        var newVal = me.openSum;
    else {
        var oldVal = remEuropeanComma(me.Main.components.info.input.properties.attributes.value);
        newVal = (oldVal ? parseFloat(oldVal) : 0) + parseFloat(noteAmount);
    }

    newVal = newVal.toString().replace(".", ",");
    me.Main.components.info.input.properties.attributes.value = newVal;

    me.Main.components.info.input.reAttribute();
}

legacy.getSumAmount = function(message) {
    var amount = remEuropeanComma(this.Main.components.info.input.properties.attributes.value);
    if (!amount && message) {
        var text = POS.lang.getText("MESSAGES", "NO_AMOUNT");
        POS.message.show(text, "warning", "OK");
        return 0;
    }
    return parseFloat(amount);
}

legacy.getFreeTAN = function() {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT TAN FROM PPCTANS WHERE Used = 0 ORDER BY RANDOM() LIMIT 1";
    $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
        try {
            var myTAN = rows[0].TAN;
            //r.free()
        } catch (e) {
            myTAN = 0;
        }
        dfd.resolve(myTAN);
        //return myTAN;
    });
    return dfd.promise();
}

legacy.cancelTAN = function(myTAN) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "UPDATE PPCTANS SET Used = 1 WHERE TAN = '" + myTAN + "'";
    return POS.SQLiteCon.execute(sql);
}

legacy.charge = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var amount = me.getSumAmount(true);
    if (!amount)
        return;
    /*
        if (me.Main.BonManager.currentBon.length > 0 && me.Main.BonManager.currentBon[0].type != 'REC' && me.Main.BonManager.currentBon[0].product.ean != 'VTPPC') { //REC  Reklamation!!!
            var text = POS.lang.getText("MESSAGES", "PPC_ONLY_POS");
            POS.message.show(text, "warning", "OK");
            log.add(1, "Error", "nur PPC - leaving", err);
            return;
        }*/
    if (amount < me.leastAmountForPPC){// && me.Main.BonManager.currentBon[0].type != 'REC') {
        var text = POS.lang.getText("MESSAGES", "PPC_TOO_LESS_AMOUNT").replace("%X%", me.leastAmountForPPC);
        POS.message.show(text, "warning", "OK");
        return;
    }

    $.when(me.getFreeTAN()).then(function(myTAN) {
      /*  if (!myTAN) {
            var text = POS.lang.getText("MESSAGES", "PPC_NO_TAN");
            POS.message.show(text, "warning", "OK");
            return;
        }*/
        $.when(Trans.getPPCProduct()).then(function(val) {
            POS.hourGlass.show(POS.lang.getText("MESSAGES", "PLEASE_WAIT"));
            if (!val) {
                var text = "Wertkarten-Produkt nicht gefunden!"; //POS.lang.getText("MESSAGES", "PPC_NOT_CHARGED");
                POS.message.show(text, "warning", "OK");
                return;
            }

            var sql = "UPDATE PPCARD_TANS set Used=1 where TAN=" + myTAN + " and POS_ID=" + POS.POSId;
            $.when(me.sendQuery(sql, me.tanCallback)).then(function() {
                $.when(me.cancelTAN(myTAN)).then(function() {});

            });
        });
    });
}

legacy.tanCallback = function(data, err) {

    try {
        var me = POS.sessions.getSessionComponent().cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }
    var defret = $.Deferred();
 /*   if (err) {
        var text = POS.lang.getText("MESSAGES", "PPC_NO_TAN");
        POS.message.show(text, "warning", "OK");
        log.add(1, "Error", "PPC kein TAN 2 - leaving", err);
        return;
    }
*/
    var d = new Date();
    var TS = (d / 1000).toFixed(0);
    //TR_ID,
    var fields = "(CardNumber,TS,Type,BillNumber,Amount,POS_ID,Pending,Exported)";
    window.sql = "INSERT into logi.PPCARD_TRANSACTIONS " + fields + " VALUES ('" + me.cardNumber + "'," + TS + ",'IN'," + me.Main.BonManager.currentBonId + ",0," + POS.POSId + ",0,0)";
    $.when(me.sendQuery(sql, me.chargeCallback)).then(function() {
        defret.resolve();

    });
    return defret.promise();

}

legacy.chargeCallback = function(data, err) {

    try {
        var me = POS.sessions.getSessionComponent().cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }
    var defret = $.Deferred();
    POS.hourGlass.hide();
    if (err) {

        POS.message.show("Transaction nicht erfolgreich!", "warning", "OK");
        log.add(1, "Error", "PPC Charge nicht erfolgreich", err);
        return;
    }

    //var sql = "SELECT * FROM logi.PPCARD_TRANSACTIONS where BonNumber=" + me.Main.BonManager.currentBonId + " and POS_ID=" + POS.POSId;
    var sql = "SELECT * FROM logi.PPCARD_TRANSACTIONS where BonNumber=0 and POS_ID=" + POS.POSId;
    $.when(me.sendQuery(sql, me.getFromBonNumber)).then(function() {
        defret.resolve();
    });


    return defret.promise();
}

legacy.getFromBonNumber = function(data, err) {

    try {
        var me = POS.sessions.getSessionComponent().cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }
    var defret = $.Deferred();
    var trId = data[data.length - 1].TR_ID;
    var sumCredit = me.availableCredit + me.getSumAmount(false);

    $.when(Trans.getPPCProduct()).then(function(val) {
        $.when(me.Main.BonManager.preAddEntryPOS(1, val, me.getSumAmount(false))).done(function() {
            var entry = me.Main.BonManager.currentBon[me.Main.BonManager.currentBon.length - 1];
            entry.interaction = trId;
            //me.Main.BonManager.prepaidCardCredits = trId;
            $.when(Trans.changeInteraction(entry, trId)).then(function() {
                entry.text2 = me.availableCredit + ";" + me.cardNumber;
                $.when(Trans.changeText2(entry, entry.text2)).then(function() {
                    //$.when(me.sendBonNumber(trId, me.Main.BonManager.currentBonId)).then(function () {
                    me.Main.vacuumInfoValue(me.Main);
                    me.doClose(me);
                    POS.hourGlass.hide();
                    defret.resolve();
                    //});
                });
            });
        });
    });
    return defret.promise();
}

legacy.payment = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    if (!me.openSum) {
        var text = POS.lang.getText("MESSAGES", "PPC_NOTHING_TO_PAY");
        POS.message.show(text, "warning", "OK");
        return;
    }

    me.paymentAmount = me.getSumAmount(false);
    //    if (!me.availableCredit || (me.availableCredit > me.openSum))
    if (me.availableCredit > 0 && (me.availableCredit >= me.openSum)) {
        if (!me.paymentAmount || (me.paymentAmount && me.paymentAmount > me.openSum)) {
            me.paymentAmount = me.openSum;
        }
    } else if (me.availableCredit <= 0.01) {
        POS.message.show("Nicht genug Guthaben!", "warning", "OK");
        return;

    } else if (me.openSum > me.availableCredit) {
        me.paymentAmount = me.availableCredit;
    }

    /*else {
        me.paymentAmount = me.availableCredit;

    }
*/

    if (parseFloat(me.paymentAmount) > me.openSum)
        me.paymentAmount = me.openSum;

    /*$.when(me.getFreeTAN()).then(function (myTAN) {
    	if (!myTAN) {
    		var text = POS.lang.getText("MESSAGES", "PPC_NO_TAN");
    		POS.message.show(text, "warning", "OK");
    		return;
    	}*/

    var bonId = me.Main.BonManager.currentBonId;
    POS.hourGlass.show(POS.lang.getText("MESSAGES", "PLEASE_WAIT"));
    var d = new Date();
    var TS = (d / 1000).toFixed(0);

    var sum = me.paymentAmount * -1;
    var fields = "(CardNumber,TS,Type,BillNumber,Amount,POS_ID,Pending,Exported)";

    window.sql = "INSERT into logi.PPCARD_TRANSACTIONS " + fields + " VALUES ('" + me.cardNumber + "'," + TS + ",'OUT'," + me.Main.BonManager.currentBonId + "," + sum + "," + POS.POSId + ",0,0)";
    log.add(1, "Info", "Payment: ", sql);
    $.when(me.sendQuery(sql, me.paymentCallback)).then(function() {

        /*$.when(me.sendQData(me.serverAddress, me.remotePort, me.paymentCallback, "GET /ppc_payment.html?sess=" + me.Main.UID + ";tan=" + myTAN + ";pos=" +
        		POS.POSId + ";amount=" + me.paymentAmount + ";card=" + me.cardNumber + ";bon=" + bonId + " HTTP/1.1\r\n\r\n")).done(function () {
        	var cl = new CRunClient(me.serverAddress, me.remotePort, me.paymentCallback);
        	$.when(cl.clientready).then(function (client) {
        	client.outputStream.sendRaw("GET /ppc_payment.html?sess=" + me.Main.UID + ";tan=" + myTAN + ";pos=" +
        	POS.POSId + ";amount=" + me.paymentAmount + ";card=" + me.cardNumber + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");
        	client.close();*/
    });

    //});
}

legacy.paymentCallback = function(data, err) {

    try {
        var me = POS.sessions.getSessionComponent().cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }
    var defret = $.Deferred();
    POS.hourGlass.hide();
    if (err) {

        POS.message.show("Transaction nicht erfolgreich!", "warning", "OK");
        log.add(1, "Error", "PPC Payment nicht erfolgreich", err);
        return;
    }


    //$.when(me.cancelTAN(myTAN)).done(function () {

    $.when(Trans.getPaymentId('PPC')).then(function(PaymentId) {
        $.when(me.Main.BonManager.addEntryPAY(PaymentId, me.paymentAmount)).done(function() {
            //$.when(me.cancelTAN(myTAN)).done(function () {
            me.doClose(me);
            POS.hourGlass.hide();
            defret.resolve(1);

            //});
        });
    });


    //defret.resolve(1);
    //return 1;
    //});
    return defret.promise();
}

legacy.sendBonNumber = function(trId, bonId) {

    var currentSession = POS.sessions.getSessionComponent();
    try {
        var me = currentSession.cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }
    var sql = "UPDATE logi.PPCARD_TRANSACTIONS set BonNumber=" + bonId + " where TR_ID=" + trId;
    return me.sendQuery(sql);

    /*return this.sendQData(this.serverAddress, this.remotePort, this.dummyCallback, "GET /ppc_register_bon.html?pos=" + POS.POSId +
    	";bon=" + bonId + ";transaction=" + trId + " HTTP/1.1\r\n\r\n");
    var cl = new CRunClient(this.serverAddress, this.remotePort, this.dummyCallback);
    $.when(cl.clientready).then(function (client) {
    client.outputStream.sendRaw("GET /ppc_register_bon.html?pos=" + POS.POSId +
    ";bon=" + bonId + ";transaction=" + trId + " HTTP/1.1\r\n\r\n");
    client.close();*/
}

legacy.sendBillNumber = function(bonId, billId) {

    var currentSession = POS.sessions.getSessionComponent();
    try {
        var me = currentSession.cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }
    var sql = "UPDATE logi.PPCARD_TRANSACTIONS set BillNumber=" + billId + ",Pending=1,Exported=1 where BonNumber=" + bonId;
    return me.sendQuery(sql);

    /*return this.sendQData(this.serverAddress, this.remotePort, this.dummyCallback, "GET /ppc_register_bill.html?pos=" + POS.POSId +
    	";bon=" + bonId + ";bill=" + billId + " HTTP/1.1\r\n\r\n");

    var cl = new CRunClient(this.serverAddress, this.remotePort, this.dummyCallback);
    $.when(cl.clientready).then(function (client) {
    client.outputStream.sendRaw("GET /ppc_register_bill.html?pos=" + POS.POSId +
    ";bon=" + bonId + ";bill=" + billId + " HTTP/1.1\r\n\r\n");
    client.close();*/
}

legacy.validatePayment = function(bonId, billId, trId, amount) {

    var sql = "UPDATE PPCARD_TRANSACTIONS set Amount=" + amount + ",BonNumber=" + bonId + ",Billnumber=" + billId + ",Pending=1,Exported=1 where TR_ID=" + trId;
    var prom = this.sendQuery(sql);
    //POS.DataExport.stopTunnelToMySQL();
    return prom;

    /*return this.sendQData(this.serverAddress, this.remotePort, this.dummyCallback, "GET /ppc_validate_payment.html?bill=" + billId +
    	";transaction=" + trId + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");

    var cl = new CRunClient(this.serverAddress, this.remotePort, this.dummyCallback);
    $.when(cl.clientready).then(function (client) {
    client.outputStream.sendRaw("GET /ppc_validate_payment.html?bill=" + billId +
    ";transaction=" + trId + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");
    client.close();*/
}

legacy.addCancelledPayment = function(bonId, billId, amount) {

    var sql = "UPDATE PPCARD_TRANSACTIONS set Amount=0 where BonNumber=" + bonId;
    return this.sendQuery(sql);

    /*return this.sendQData(this.serverAddress, this.remotePort, this.dummyCallback, "GET /ppc_cancel_payment.html?bill=" + billId +
    	";pos=" + POS.POSId + ";bon=" + bonId + ";amount=" + amount + " HTTP/1.1\r\n\r\n");

    var cl = new CRunClient(this.serverAddress, this.remotePort, this.dummyCallback);
    $.when(cl.clientready).then(function (client) {
    client.outputStream.sendRaw("GET /ppc_cancel_payment.html?bill=" + billId +
    ";pos=" + POS.POSId + ";bon=" + bonId + ";amount=" + amount + " HTTP/1.1\r\n\r\n");
    client.close();*/
}

legacy.addCancelledCharge = function(bonId, billId, amount) {

    var sql = "UPDATE PPCARD_TRANSACTIONS set Amount=0 where BonNumber=" + bonId;
    // war "me.sendQuery" - me gibt es hier nicht (schon im Legacy): Storno
    // eines Bons mit Wertkarten-Aufladung brach mit ReferenceError ab.
    return this.sendQuery(sql);

    /*return this.sendQData(this.serverAddress, this.remotePort, this.dummyCallback, "GET /ppc_cancel_charge.html?bill=" + billId +
    	";pos=" + POS.POSId + ";bon=" + bonId + ";amount=-" + amount + " HTTP/1.1\r\n\r\n");

    var cl = new CRunClient(this.serverAddress, this.remotePort, this.dummyCallback);
    $.when(cl.clientready).then(function (client) {
    client.outputStream.sendRaw("GET /ppc_cancel_charge.html?bill=" + billId +
    ";pos=" + POS.POSId + ";bon=" + bonId + ";amount=-" + amount + " HTTP/1.1\r\n\r\n");
    client.close();*/

}

legacy.deletePaymentsInBon = function(bonId) {
    //return this.sendQData(this.serverAddress, this.remotePort, this.dummyCallback, "GET /ppc_delete_payments.html?pos=" + POS.POSId + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");
return true;
    /*var cl = new CRunClient(this.serverAddress, this.remotePort, this.dummyCallback);
    $.when(cl.clientready).then(function (client) {
    client.outputStream.sendRaw("GET /ppc_delete_payments.html?pos=" + POS.POSId + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");
    client.close();*/

}

legacy.checkBonCancellation = function(sessId, posId, bonId) {
    //return this.sendQData(this.serverAddress, this.remotePort, this.checkBonTransactionCallback, "GET /ppc_check_cancellation.html?sess=" + sessId + ";pos=" +
      //  POS.POSId + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");
return true;
    /*var cl = new CRunClient(this.serverAddress, this.remotePort, this.checkBonTransactionCallback);
    $.when(cl.clientready).then(function (client) {
    client.outputStream.sendRaw("GET /ppc_check_cancellation.html?sess=" + sessId + ";pos=" +
    POS.POSId + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");
    client.close();*/

}

legacy.checkBonPayment = function(sessId, posId, bonId) {

    try {
        var me = POS.sessions.getSessionComponent().cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }
    var sql = "UPDATE PPCARD_TRANSACTIONS set Pending=1,Exported=1 where BonNumber=" + bonId;
    me.mode = "OUT";
    return this.sendQuery(sql, this.checkBonTransactionCallback);

    /*return this.senQdData(this.serverAddress, this.remotePort, this.checkBonTransactionCallback, "GET /ppc_check_payment.html?sess=" + sessId + ";pos=" +
    		POS.POSId + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");

    	var cl = new CRunClient(this.serverAddress, this.remotePort, this.checkBonTransactionCallback);
    	$.when(cl.clientready).then(function (client) {
    	client.outputStream.sendRaw("GET /ppc_check_payment.html?sess=" + sessId + ";pos=" +
    	POS.POSId + ";bon=" + bonId + " HTTP/1.1\r\n\r\n");
    	client.close();*/

}

legacy.checkBonTransactionCallback = function(data, err) {

    if (err) {
        var text = "Möglicherweise ist die Buchung nicht erfolgt.\nNach Abschluss der Transaktion bitte Wertkarten-Buchungen überprüfen.\nWenn die Buchung fehlt Bon stornieren und Aktion wiederholen!";
        POS.message.show(text, "warning", "OK");
    }
    var currentSession = POS.sessions.getSessionComponent();
    try {
        var me = currentSession.cmpPrepaidPayment;
    } catch (e) {
        log.add(4, "Info", "PPC screen is no more active - leaving", "");
        return;
    }

    switch (me.mode) {
        case 'IN':
            return currentSession.cmpCopies.checkPPCCancellationAnswer("OK", null); //promise
            break;
        case 'OUT':
            // abgebuchter Betrag, nicht die offene Summe: bei Teilzahlung
            // (Rest bar) stand sonst ein negatives Guthaben am Bon
            var prepaidCardCredits = me.availableCredit - parseFloat(me.paymentAmount);
            prepaidCardCredits = me.cardNumber + ";" + Math.round(prepaidCardCredits * 100) / 100;
            return currentSession.BonManager.checkPPCPaymentAnswer("OK", prepaidCardCredits); //promise
            break;
    }
}

legacy.dummyCallback = function(data) {}

legacy.updateDisplay = function() {
    Display.addLine();
    Display.addElement(POS.lang.getText("LABELS", "PPC_CREDIT") + ":", 0, 0, 0, 19);
    Display.addElement(float2StringD2(this.availableCredit) + " &euro;", 19, 1, 0, 19);
    Display.addLine();
    Display.addElement("", 0, 0, 0, 19);

    Display.out();
}

legacy.close = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);
    me.doClose(me, true);
}

legacy.doClose = function(me, enableAll) {
    enableAll = true;
    $("#orderframe").remove();
    if (enableAll) {
        me.Main.components.bonfnc.setEnabled(true);
        me.Main.components.payment.setEnabled(true);
        me.Main.components.payment2.setEnabled(true);
        me.Main.components.bonedit.setEnabled(true);
        me.Main.components.prodSelect.setEnabled(true);
        me.Main.components.leftPad.setEnabled(true);
    } else {
        me.Main.components.payment.setEnabled(true);
        me.Main.components.payment2.setEnabled(true);
        me.Main.components.bonfnc.setEnabled(true);
        me.Main.components.bonedit.setEnabled(false);
        me.Main.components.prodSelect.setEnabled(false);
        me.Main.components.leftPad.setEnabled(false);
    }
    me.Main.vacuumInfoValue(me.Main);

    POS.timeout.unregister("testPPCPaymentPing");
    POS.timeout.unregister("testVTPing");
    me.removeMe();

    log.add(4, "Info", "End prepaid card mode", "");
}

// ===== Screen-Vertrag ======================================================
export const CPrepaidCardPayment = defineReactScreen({
  className: 'CPrepaidCardPayment',
  addclass: 'CPrepaidCardPayment CashWindow',
  htmlType: 'div',
  Screen: PrepaidCardPaymentScreen,
  // properties.styles war im Legacy-Konstruktor komplett AUSKOMMENTIERT -
  // der Wurzelknoten bekommt also keine eigenen Stile. Sichtbar schaltet ihn
  // fremder Code per direktem DOM-Zugriff (wie im Legacy).
  rootStyles: {},
  initialState: {
    titel: '', titelKlasse: '', inhalt: XML_EMPTY, preis: XML_EMPTY,
    guthaben: XML_CREDIT,
    notizKnoepfe: [],   // welche Scheintaste gezeichnet ist (makeNoteButtons)
  },
  // Felder des Legacy-Konstruktors (woertlich) - in fields() und NICHT in
  // prepare(): CMainPOS.doPrepaidCardPayment setzt cardNumber zwischen
  // addChild() und draw(), und CPaymentProcessor/CPosReceiptList rufen
  // Methoden auf einem nie gezeichneten new CPrepaidCardPayment() auf
  // (serverAddress). In prepare() ging die Karte als '0' an den Server und
  // die EAN fehlte am Aufbuchungs-Bon (Meldung 20.10.2026). Main legt der
  // Bridge-Konstruktor an.
  fields: () => ({
    leastAmountForPPC: 10, // euros
    payAmount: 0,
    openSum: null,
    online: false,
    cardNumber: 0,
    availableCredit: -1,
    serverAddress: POS.EnvProperties.ORDERINGSSERVER,
    pingVTAddress: POS.EnvProperties.POSHELP,
    pingVTSuccess: false,
    pingFreq: 5 * 4, // to check every 5 seconds
  }),
  prepare(bridge) {
    // --- Legacy-prepare, ohne die beiden createChildrenFromXML (= JSX) ---
    bridge.Main = POS.sessions.getSessionComponent();

    // contentText/priceText-Stile stehen als Konstanten in der JSX (S.inhalt,
    // S.preis) - dieselben Werte, nur nicht mehr per properties.styles.

    var message = 'Gegeben:<br>';
    message += 'Offen:';

    var amounts = bridge.getAmounts();

    // CLASS-AUS-WERT: der Titel wird VOR dem Bauen gesetzt, der Builder
    // friert ihn deshalb in die Klasse ein. Spaetere reValue() aendern nur
    // noch den Text - titelKlasse bleibt darum unberuehrt.
    var titel = POS.lang.getText('LABELS', 'PPCARD_PAYMENT');
    bridge.state.titel = titel;
    bridge.state.titelKlasse = titel;
    if (amounts) {
      bridge.state.inhalt = message;
      bridge.state.preis = amounts;
    }

    // okButton auf hidden steht in der JSX (React ist Eigentuemer).
    // chargeButton/payButton/backButton-Handler ebenso; closeButton hat auch
    // hier KEINEN Handler - im Legacy ist seine Verdrahtung auskommentiert.

    bridge.Main.components.bonfnc.setEnabled(false);
    bridge.Main.components.payment.setEnabled(false);
    bridge.Main.components.payment2.setEnabled(false);
    bridge.Main.components.bonedit.setEnabled(false);
    bridge.Main.components.prodSelect.setEnabled(false);
    bridge.Main.components.leftPad.setEnabled(false);

    bridge.Main.vacuumInfoValue(bridge.Main);


    bridge.data = null;
  },
  legacyMethods: legacy,
});
